import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export const WishlistButton = ({ product, className = "", size = "h-9 w-9" }) => {
  const { wishlist, toggleWishlist, user } = useAuth();
  const navigate = useNavigate();
  const active = wishlist.includes(product.id);

  const onClick = (e) => {
    e.stopPropagation();
    if (!user) {
      toast("Accedi per salvare i preferiti");
      navigate("/login");
      return;
    }
    toggleWishlist(product.id);
  };

  return (
    <button
      onClick={onClick}
      data-testid={`wishlist-${product.id}`}
      aria-label="Aggiungi ai preferiti"
      className={`grid ${size} place-items-center rounded-full backdrop-blur transition-transform hover:scale-110 active:scale-90 ${className}`}
    >
      <Heart className={`h-4 w-4 transition-colors ${active ? "fill-red-500 text-red-500" : "text-ink"}`} strokeWidth={1.8} />
    </button>
  );
};
